import styled from '@emotion/styled';
import { Avatar, Box, TableCell, Typography } from '@mui/material';

export const Title = styled(Typography)`
 padding-left: 8px;
 margin-bottom: -16px;
 z-index: 1;
 font-size: 2em;
 text-shadow: 2px 2px black;
`;

export const TableContainer = styled(Box)`
 padding-top: 24px;
`;

export const ModeCircleContainer = styled(Box)`
 position: relative;
 display: inline-block;
`;

interface AvatarStyledProps {
  backgroundColor: string;
}

export const AvatarStyled = styled(Avatar, {
  shouldForwardProp: (prop) => prop !== "backgroundColor",
}) <AvatarStyledProps>`
  background-color:  ${({ backgroundColor }) => backgroundColor};
  height: 40px;
  width: 40px;

  & img {
    object-fit: contain;
    width: 80%;
    height: 80%;
  }
`

export const Label5v5 = styled(Typography)`
  position: absolute;
  bottom: -8px;
  right: -8px;
  font-size: 16px;
  text-shadow: 2px 2px black;
`;

interface TableCellIconStyledProps {
  isMobile?: boolean;
}

export const TableCellIconStyled = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "isMobile",
}) <TableCellIconStyledProps>`
  padding: ${({ isMobile }) => (isMobile ? "4px" : "8px")};
  display: flex;
  align-items: center;
  justify-content: center;
`